import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { ErrorBoundary } from '@/components/ui/error-boundary'
import { PostHogProvider } from 'posthog-js/react'
import { ServerError } from '@/pages/error/ErrorPages'
import { registerServiceWorker } from './registerSW'

const rootElement = document.getElementById('root');

registerServiceWorker();

// Suppress benign ResizeObserver errors that can cause React to crash (usually from recharts/ui components)
window.addEventListener('error', (e) => {
  if (
    e.message === 'ResizeObserver loop limit exceeded' ||
    e.message === 'ResizeObserver loop completed with undelivered notifications.'
  ) {
    e.stopImmediatePropagation();
  }
});

if (rootElement) {
  createRoot(rootElement).render(
    <StrictMode>
      <PostHogProvider
        apiKey={import.meta.env.VITE_PUBLIC_POSTHOG_KEY}
        options={{
          api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
          persistence: 'localStorage',
          autocapture: true,
          capture_pageview: false, // We'll handle this in App.tsx to respect consent
        }}
      >
        <ErrorBoundary fallback={<ServerError />}>
          <App />
        </ErrorBoundary>
      </PostHogProvider>
    </StrictMode>,
  );
}
